import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fmtEUR } from "../lib/format";
import { api } from "../lib/api";

export default function KassaSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      navigate("/kassa");
      return;
    }
    let attempts = 0;
    const maxAttempts = 10;
    const interval = setInterval(async () => {
      attempts++;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          clearInterval(interval);
          setStatus("paid");
          setOrder(data.order);
          toast.success(`Order ${data.order?.ordernummer || ""} geplaatst!`);
        } else if (data.status === "expired") {
          clearInterval(interval);
          setStatus("expired");
        }
      } catch (e) {
        // continue polling
      }
      if (attempts >= maxAttempts && status === "checking") {
        clearInterval(interval);
        setStatus("timeout");
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [sessionId, navigate, status]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-soft)] p-6" data-testid="kassa-success-screen">
      <div className="tile p-10 max-w-lg w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-16 h-16 mx-auto animate-spin" />
            <h1 className="font-display text-3xl font-bold mt-4">Betaling controleren…</h1>
            <p className="text-[var(--ink-soft)] mt-2">Een moment geduld a.u.b.</p>
          </>
        )}
        {status === "paid" && order && (
          <>
            <CheckCircle2 className="w-20 h-20 mx-auto text-[var(--success)]" />
            <h1 className="font-display text-4xl font-bold mt-4">Betaald!</h1>
            <div
              className="mt-4 inline-block px-6 py-3 rounded-3xl font-display text-5xl font-bold text-white"
              style={{ background: order.team_kleur }}
              data-testid="success-ordernumber"
            >
              {order.ordernummer}
            </div>
            <p className="text-[var(--ink-soft)] mt-3">{fmtEUR(order.totaal)}</p>
            <button
              onClick={() => navigate("/kassa")}
              className="btn-press mt-6 px-6 py-3 rounded-full bg-[var(--ink)] text-white font-semibold"
              data-testid="success-continue"
            >
              Volgende klant →
            </button>
          </>
        )}
        {(status === "expired" || status === "timeout") && (
          <>
            <XCircle className="w-20 h-20 mx-auto text-[var(--danger)]" />
            <h1 className="font-display text-3xl font-bold mt-4">Betaling niet voltooid</h1>
            <button
              onClick={() => navigate("/kassa")}
              className="btn-press mt-6 px-6 py-3 rounded-full bg-[var(--ink)] text-white font-semibold"
              data-testid="success-retry"
            >
              Terug naar kassa
            </button>
          </>
        )}
      </div>
    </div>
  );
}
